<dynamic-form-v2
    *ngIf="!isLoading"
    entityType="store-listing"
    [formName]="title"
    [record]="StoreListingRecord"
    [fields]="fields"
    [viewRoute]="viewRoute"
>
</dynamic-form-v2>
